package com.milta.feature.route.domain.entity

import com.milta.core.network.PagedResult

/** Full response of `GET /api/v1/routes/{routeId}/proofs` (MIL-52, Screen B). */
data class RouteProofsResult(
    val route: RouteProofsSummary,
    val proofs: PagedResult<DeliveryProofHistoryItem>,
)
